import axios from '../../utils/axiosConfig';
import config from '../../utils/Config';

let getCoordinatorPageData =  () => {
    return new Promise((resolve, reject) => {
        axios.get(config.basePath + 'coordinator/dccordinators',{params: {academicyear: localStorage.getItem("academicyear")
      }}).then(result => {
            resolve(result)
        }).catch((err) => {

            if(err && err.response && err.response.data && err.response.data && err.response.data.message){
                reject({
                    message: err.response.data.message
                })
            } else {
                reject({
                    message: "Unable to fetch coordinator data"
                })
            }
        })
    })
}

let trasnferDc =  (userObj) => {
    return new Promise((resolve, reject) => {
        axios.post(config.basePath + 'coordinator/transferDC', userObj).then(result => {
            resolve(result)
        }).catch((err) => {

            if(err && err.response && err.response.data && err.response.data && err.response.data.message){
                reject({
                    message: err.response.data.message
                })
            } else {
                reject({
                    message: "Unable to transfer DC to District"
                })
            }
        })
    })
}

const downloadExcelDC  = (userObj) => {
    return new Promise((resolve, reject) => {
        axios.get(config.basePath + 'coordinator/getDCExcel', {params:{academicyear: localStorage.getItem("academicyear")}, responseType: 'blob' })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.error('Error downloading Excel file:', error);
      });
    })
}

const downloadExcelSurvey  = () => {
    return new Promise((resolve, reject) => {
        axios.get(config.basePath + 'common/surveyexcel', { params:{academicyear: localStorage.getItem("academicyear")},  responseType: 'blob' })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.error('Error downloading Excel file:', error);
      });
    })
}

const downloadExcelDbuser  = () => {
    return new Promise((resolve, reject) => {
        axios.get(config.basePath + 'dashboard/getalldashboarduser', { params:{academicyear: localStorage.getItem("academicyear"),expdate:localStorage.getItem("selectedYear")}, responseType: 'blob' })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.error('Error downloading Excel file:', error);
      });
    })
}


const downloadExcelEnr  = () => {
    return new Promise((resolve, reject) => {
        axios.get(config.basePath + 'manageschool/getallschoolexcel', {params:{academicyear: localStorage.getItem("academicyear")}, responseType: 'blob' })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.error('Error downloading Excel file:', error);
      });
    })
}

const downloadExcelReport  = () => {
    return new Promise((resolve, reject) => {
        axios.get(config.basePath + 'report/getallreportdata', {params:{academicyear: localStorage.getItem("academicyear")}, responseType: 'blob' })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.error('Error downloading Excel file:', error);
      });
    })
}

const costEstimateService = {
    getCoordinatorPageData,
    trasnferDc,
    downloadExcelDC,
    downloadExcelSurvey,
    downloadExcelDbuser,
    downloadExcelEnr,
    downloadExcelReport
}

export default costEstimateService 